import type { TableRow } from './types'

export function createEmptyRow(): TableRow {
  return {
    id: Date.now().toString(),
    clientName: '',
    requestId: '',
    code: '',
    clientCategory: '',
    date: '',
    partNumber: '',
    brand: '',
    qty: null,
    unit: '',
    totalY: null,
    soprovod: '',
    priority: '',
    deadline: '',
    comments: '',
    targetPrice: null,
    status: '',
  }
}

/** Данные таблицы переживают unmount при смене вкладки */
export const rowStore = { current: [] as TableRow[] }
